/* ==========================================================================
   Everymood Comparison Page — Best Body Mists of 2026
   Production tracking + sticky-CTA controller (server-rendered Liquid)
   File: assets/comparison-best-body-mists-2026.js
   PostHog SDK loaded site-wide via shop.metafields.foxtheme.code_head;
   this file calls window.posthog directly (with opt-out check).
   ========================================================================== */

(function () {
  "use strict";

  /* ---------- 1. Configuration ---------- */
  var PAGE_SLUG       = "comparison-best-body-mists-2026";
  var TOP_PICK_HANDLE = "hydrating-body-hair-mist-smell-the-rose-100-ml";
  var CATEGORY        = "body-mists";
  var YEAR            = 2026;

  if (typeof window === "undefined") return;

  var root = document.querySelector(".em-comparison");
  if (!root) return;

  /* ---------- 2. PostHog pre-flight + capture wrapper ---------- */
  function preflightPostHog() {
    if (typeof window.posthog === "undefined" || typeof window.posthog.capture !== "function") {
      console.warn(
        "[comparison] PostHog not loaded - confirm shop.metafields.foxtheme.code_head injects the SDK. " +
        "Events will be skipped until SDK is available."
      );
      return false;
    }
    return true;
  }

  function track(event, props) {
    if (!window.posthog || typeof window.posthog.capture !== "function") {
      console.warn("[comparison] posthog not loaded; event dropped:", event, props);
      return;
    }
    if (typeof window.posthog.has_opted_out_capturing === "function" && window.posthog.has_opted_out_capturing()) {
      return;
    }
    var baseProps = {
      page_slug:       PAGE_SLUG,
      page_handle:     PAGE_SLUG,
      top_pick_handle: TOP_PICK_HANDLE,
      category:        CATEGORY,
      year:            YEAR,
      page_type:       "comparison"
    };
    var merged = {};
    var k;
    for (k in baseProps) merged[k] = baseProps[k];
    if (props) for (k in props) merged[k] = props[k];
    try {
      window.posthog.capture(event, merged);
    } catch (e) {
      console.warn("[comparison] posthog.capture threw:", e);
    }
  }

  function setPersonProps(props) {
    if (!window.posthog || typeof window.posthog.setPersonProperties !== "function") return;
    if (typeof window.posthog.has_opted_out_capturing === "function" && window.posthog.has_opted_out_capturing()) return;
    try {
      window.posthog.setPersonProperties(props);
    } catch (e) { /* swallow */ }
  }

  /* ---------- 3. Page-view event ---------- */
  function firePageView() {
    var rankedCount        = root.querySelectorAll("[data-rank]").length;
    var hasLifestyleImage  = !!document.querySelector(".spotlight__media img[src]");
    track("comparison_page_viewed", {
      ranked_count:        rankedCount,
      has_lifestyle_image: hasLifestyleImage,
      has_expert:          false
    });
    setPersonProps({
      last_comparison_viewed:   PAGE_SLUG,
      last_comparison_top_pick: TOP_PICK_HANDLE,
      last_comparison_at:       new Date().toISOString()
    });
  }

  /* ---------- 4. Section-view tracking (fire-once per section) ---------- */
  function setupSectionViewTracking() {
    var sections = [
      { id: "section-hero",        name: "hero" },
      { id: "section-credibility", name: "credibility" },
      { id: "section-ranked-list", name: "ranked_list" },
      { id: "section-spotlight",   name: "spotlight" },
      { id: "section-closer",      name: "closer" }
    ];
    if (!("IntersectionObserver" in window)) return;
    var observed = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !observed[entry.target.id]) {
          observed[entry.target.id] = true;
          var meta = null;
          for (var i = 0; i < sections.length; i++) {
            if (sections[i].id === entry.target.id) { meta = sections[i]; break; }
          }
          track("comparison_section_viewed", {
            section_id:   entry.target.id,
            section_name: meta ? meta.name : entry.target.id
          });
        }
      });
    }, { threshold: 0.35 });
    sections.forEach(function (s) {
      var el = document.getElementById(s.id);
      if (el) obs.observe(el);
    });
  }

  /* ---------- 5. Scroll-depth tracking (25/50/75/100%) ---------- */
  function setupScrollDepthTracking() {
    var milestones = [25, 50, 75, 100];
    var fired = {};
    function getScrollPercent() {
      var docEl  = document.documentElement;
      var scroll = window.scrollY || window.pageYOffset;
      var total  = (docEl.scrollHeight || document.body.scrollHeight) - window.innerHeight;
      if (total <= 0) return 100;
      return Math.min(100, Math.round((scroll / total) * 100));
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var pct = getScrollPercent();
        milestones.forEach(function (m) {
          if (pct >= m && !fired[m]) {
            fired[m] = true;
            track("comparison_scroll_depth", { depth: m });
          }
        });
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 6. Card-view tracking ---------- */
  function setupCardViewTracking() {
    if (!("IntersectionObserver" in window)) return;
    var cards = root.querySelectorAll("[data-rank]");
    var observed = new WeakSet();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !observed.has(entry.target)) {
          observed.add(entry.target);
          track("comparison_product_card_viewed", {
            rank:           parseInt(entry.target.getAttribute("data-rank"), 10),
            brand:          entry.target.getAttribute("data-brand") || "",
            product_handle: entry.target.getAttribute("data-product-handle") || ""
          });
        }
      });
    }, { threshold: 0.5 });
    cards.forEach(function (card) { obs.observe(card); });
  }

  /* ---------- 7. VS-table-view tracking (fire-once) ---------- */
  function setupVsTableTracking() {
    if (!("IntersectionObserver" in window)) return;
    var table = root.querySelector(".vs-table");
    if (!table) return;
    var fired = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !fired) {
          fired = true;
          track("comparison_table_viewed", {
            row_count: entry.target.querySelectorAll("tbody tr").length
          });
        }
      });
    }, { threshold: 0.5 });
    obs.observe(table);
  }

  /* ---------- 8. Pricing-block view tracking ---------- */
  function setupPricingBlockTracking() {
    if (!("IntersectionObserver" in window)) return;
    var block = root.querySelector(".pricing-block");
    if (!block) return;
    var fired = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !fired) {
          fired = true;
          track("comparison_pricing_block_viewed");
        }
      });
    }, { threshold: 0.6 });
    obs.observe(block);
  }

  /* ---------- 9. CTA click tracking ---------- */
  function setupCtaClicks() {
    function ctaPayload(target) {
      var ctaLocation = target.getAttribute("data-cta") || "unknown";
      var ctaRank     = target.getAttribute("data-cta-rank");
      // Build "ranked-{n}" location label per spec when rank is present
      var location = ctaLocation;
      if (ctaLocation === "ranked" && ctaRank) {
        location = "ranked-" + ctaRank;
      }
      return {
        cta_location:   location,
        cta_rank:       ctaRank ? parseInt(ctaRank, 10) : null,
        product_handle: target.getAttribute("data-product-handle") || "",
        cta_url:        target.getAttribute("href") || "",
        cta_text:       (target.textContent || "").trim().slice(0, 80)
      };
    }
    root.addEventListener("click", function (e) {
      var target = e.target.closest("[data-cta]");
      if (!target) return;
      track("comparison_cta_clicked", ctaPayload(target));
    });
    var stickyCta = document.querySelector(".em-sticky-cta [data-cta]");
    if (stickyCta) {
      stickyCta.addEventListener("click", function () {
        track("comparison_cta_clicked", ctaPayload(stickyCta));
      });
    }
  }

  /* ---------- 10. Sticky-CTA visibility (mobile only) ---------- */
  function setupStickyCta() {
    var sticky = document.getElementById("emStickyCta");
    if (!sticky) return;
    if (window.matchMedia && window.matchMedia("(min-width: 720px)").matches) return;
    sticky.removeAttribute("hidden");

    var hero   = document.getElementById("section-hero");
    var closer = document.getElementById("section-closer");
    var shownFired = false;

    function updateVisibility() {
      var heroBottom = hero   ? hero.getBoundingClientRect().bottom : 0;
      var closerTop  = closer ? closer.getBoundingClientRect().top  : Infinity;
      var inWindow   = (heroBottom < 0) && (closerTop > window.innerHeight);
      var wasVisible = sticky.classList.contains("em-sticky-cta--visible");
      if (inWindow !== wasVisible) {
        sticky.classList.toggle("em-sticky-cta--visible", inWindow);
        if (inWindow && !shownFired) {
          shownFired = true;
          track("comparison_sticky_cta_shown");
        }
      }
    }
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
    }, { passive: true });
    updateVisibility();
  }

  /* ---------- 11. Init ---------- */
  function init() {
    preflightPostHog();
    firePageView();
    setupSectionViewTracking();
    setupScrollDepthTracking();
    setupCardViewTracking();
    setupVsTableTracking();
    setupPricingBlockTracking();
    setupCtaClicks();
    setupStickyCta();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
